var $ = require('jquery');

// function :: [DOM] -> [DOM] -> [Number] -> Effect
const LazyLoad = (function(spec){
	let { breakpoints } = spec;

	let imgs = [];
	let vids = [];
	let bgs = [];

	// getResponsiveUrl :: String => a : [a] -> a
	const getResponsiveUrl = (arr, el) => {
		if (arr.length === 1) {
			return arr[0];
		}

		const last = arr => arr[arr.length - 1];

		let containerWidth = el.clientWidth;
		const imgSizes = arr.map(imgUrl => {
			const params = last(imgUrl.split('?')).split('&');
			return Number(last(last(params).split('=')));
		});

		switch(true) {
			case !(imgSizes[0] <= containerWidth):
				return arr[0];
			case !(imgSizes[1] <= containerWidth):
				return arr[1];
			case !(imgSizes[2] <= containerWidth):
				return arr[2];
			default:
				return arr[3];
		}
	};

	// setImg :: DOM -> IO DOM
	const setImg = img => {
		const urls = img.getAttribute('data-src').split('*,*');

		img.setAttribute('src', getResponsiveUrl(urls, img));
		img.setAttribute('data-set', 'true');
	};
	// setBg :: DOM -> IO DOM
	const setBg = bg => {
		const urls = bg.getAttribute('data-bg').split('*,*');

		$('<img/>').attr('src', getResponsiveUrl(urls, bg)).on('load', _ => {
			$(this).remove();
			bg.setAttribute('style', 'background-image: url("' + getResponsiveUrl(urls, bg) + '")')
			bg.setAttribute('data-set', 'true');
		})
	};

	// loadImgs :: [DOM] -> (DOM -> IO DOM) -> IO DOM
	const loadImgs = (els, f) => {
		els = [].filter.call(els, isInView);
		els = [].filter.call(els, isUnset);

		[].forEach.call(els, f);
	}

	const loadVids = (els) => {
		if ("IntersectionObserver" in window) {
			const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
				[].forEach.call(entries, video => {
					if (video.isIntersecting) {
						for (let source in video.target.children) {
							let videoSource = video.target.children[source];
							if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
								videoSource.src = videoSource.dataset.src;
							}
						}

						video.target.load();
						video.target.classList.remove("lazy");
						lazyVideoObserver.unobserve(video.target);
					}
				});
			});

			[].forEach.call(els, lazyVideo => lazyVideoObserver.observe(lazyVideo));
		} else {
			els = [].filter.call(els, isInView);
			els = [].filter.call(els, isUnset);

			[].forEach.call(els, vid => {
				for (let source in vid.children) {
					let videoSource = vid.children[source];
					if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
						videoSource.src = videoSource.dataset.src;
					}

					vid.load();
				}
			});
		}
	}

	// isSet :: DOM -> Bool
	const isUnset = el => {
		return !(el.getAttribute('data-set') === 'true');
	};
	// isInView :: DOM -> Bool
	const isInView = el => {
		const rect = el.getBoundingClientRect();

		return rect.top <= window.innerHeight &&
			rect.bottom >= 0;
	};

	const staticHandler = _ => {
		if (imgs !== undefined) {
			loadImgs(imgs, setImg);
		}
		if (bgs !== undefined) {
			loadImgs(bgs, setBg);
		}
		if (vids !== undefined) {
			loadVids(vids)
		}
	};
	const resizeHandler = _ => {
		let els;
		if (imgs !== undefined) {
			els = [].filter.call(imgs, isInView);
			[].forEach.call(els, setImg);
		}
		if (bgs !== undefined) {
			els = [].filter.call(bgs, isInView);
			[].forEach.call(bgs, setBg);
		}
	}

	const init = _ => {
		imgs = document.querySelectorAll('img[data-src]');
		vids = document.querySelectorAll('video.lazy');
		bgs = document.querySelectorAll('*[data-bg]');
	};

	const concat = _ => {
		init();
		staticHandler();
	}

	if (breakpoints !== undefined) {
		window.addEventListener('resize', resizeHandler);
	}

	return {
		init,
		staticHandler,
		resizeHandler,
		concat
	}

})({
	breakpoints: [ 750, 1024, 1400, 1600 ]
});

window.onload = _ => {
	LazyLoad.init();
	LazyLoad.staticHandler();
	window.addEventListener("scroll", function () {
		LazyLoad.staticHandler();
	}, false);
}

window.LazyLoad = LazyLoad;



// WEBPACK FOOTER //
// ./src/common/LazyLoading/index.js